var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlay2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H59.99C71.0357 0 79.99 8.95431 79.99 20V59.99C79.99 71.0357 71.0357 79.99 59.99 79.99H20C8.9543 79.99 0 71.0357 0 59.99V20Z",
    fill: "url(#paint0_linear_193_195)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9949 24.7292L50.9538 27.1556C51.256 27.2267 51.5049 27.3867 51.7004 27.6355C51.8959 27.8844 51.9937 28.1599 51.9937 28.4621V41.7675C51.9937 43.1184 51.6782 44.3805 51.0471 45.5538C50.4161 46.727 49.5406 47.6869 48.4207 48.4335L39.9949 54.0596L31.5691 48.4335C30.4492 47.6869 29.5737 46.727 28.9427 45.5538C28.3116 44.3805 27.9961 43.1184 27.9961 41.7675V28.4621C27.9961 28.1599 28.0939 27.8844 28.2894 27.6355C28.4849 27.3867 28.7338 27.2267 29.036 27.1556L39.9949 24.7292ZM39.9949 27.4489L30.6625 29.5287V41.7675C30.6625 42.674 30.8714 43.5184 31.2891 44.3005C31.7068 45.0827 32.289 45.7226 33.0356 46.2204L39.9949 50.8599L46.9542 46.2204C47.7008 45.7226 48.283 45.0827 48.7007 44.3005C49.1184 43.5184 49.3273 42.674 49.3273 41.7675V29.5287L39.9949 27.4489ZM45.941 34.3549L47.8074 36.248L39.3283 44.7272L33.6755 39.0744L35.5687 37.1813L39.3283 40.9675L45.941 34.3549Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_195",
    x1: 0,
    y1: 0,
    x2: 79.99,
    y2: 79.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A855F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay2);
export default __webpack_public_path__ + "static/media/Overlay-2.bd84019798db66092e87a69dd65ef0c9.svg";
export { ForwardRef as ReactComponent };